import {Basic, Ventrata} from 'types'
import {UnitsPerBooking} from './UnitsPerBooking'
import {UnitsPerUnit} from './UnitsPerUnit'

type Props = {
  product: Ventrata.Product
  usedUnits: Ventrata.Unit[]
  counters: Record<string, number>
  availability?: Ventrata.Availability
  currency: Basic.Currency
}
export const Units = ({product, usedUnits, counters, availability, currency}: Props) => {
  switch (product.pricingPer) {
    case 'BOOKING':
      return <UnitsPerBooking usedUnits={usedUnits} counters={counters} />
    case 'UNIT':
      return <UnitsPerUnit usedUnits={usedUnits} counters={counters} availability={availability} currency={currency} />
    default:
      return null
  }
}
